import React from 'react';
import I18n from 'i18n-js';

import { mapFavoriteToEntityType } from '@reverbdotcom/commons/src/favorites/entity_type';

import { useFindFavorite, ExternalProps, FavoriteModal } from './find_favorite_context';
import { FavoriteButton } from './favorite_button';
import { CoreFindFavorite } from '../../schemas/rql';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { LoggedOutFavoriteButton } from './logged_out_favorite_button';
interface FavoriteButtonWrapperProps {
  favorite: CoreFindFavorite.Favorite;
  displayStyle?: 'banner' | 'button';
  children: JSX.Element;
  header?: string;
  subtext?: string;
}

function FavoriteButtonWrapper(props: FavoriteButtonWrapperProps) {
  if (props.displayStyle !== 'banner') {
    return props.children;
  }

  const bannerHeaderContent = props.favorite.favorited ?
    I18n.t(`discovery.favorites.banner.saved.${mapFavoriteToEntityType(props.favorite)}`) :
    (props.header || I18n.t('discovery.favorites.banner.unsaved'));

  return (
    <div className="feed-button__banner">
      <h4 className="size-150 mobile-size-130 weight-bold pb-half">
        {bannerHeaderContent}
      </h4>
      <p className="size-90">
        {props.subtext || I18n.t('discovery.favorites.saveSearchCallout')}
      </p>
      {props.children}
    </div>
  );
}

export function FavoriteButtonContainer(props: ExternalProps) {
  const {
    displayedModal,
    setDisplayedModal,
    setIsToastOpen,
    favorite,
    canFavorite,
  } = useFindFavorite();
  const user = useUser();

  const handleOpenModal = function () {
    setDisplayedModal(FavoriteModal.Save);
  };

  return (
    <div className="favorite-button">
      <FavoriteButtonWrapper
        favorite={favorite}
        displayStyle={props.displayStyle}
        header={props.header}
        subtext={props.subtext}
      >
        {
          user.loggedOut ?
            <LoggedOutFavoriteButton
              entityType={mapFavoriteToEntityType(favorite)}
              modalOpen={displayedModal === FavoriteModal.Signup}
              renderWithBanner={props.displayStyle === 'banner'}
              disabled={!canFavorite}
              onModalClose={() => { setDisplayedModal(FavoriteModal.None); }}
            />
            :
            <FavoriteButton
              renderWithBanner={props.displayStyle === 'banner'}
              entityType={mapFavoriteToEntityType(favorite)}
              openModal={handleOpenModal}
              disabled={!canFavorite}
              isFavorited={favorite.favorited}
              hideToast={() => { setIsToastOpen(false); }}
            />
        }
      </FavoriteButtonWrapper>
    </div>
  );
}
